import React, { FC } from 'react'
import { UseFormRegisterReturn } from 'react-hook-form'

interface TextInputProps {
  register: UseFormRegisterReturn
  type?: 'text' | 'email' | 'password' | 'number'
  placeholder?: string
  unit?: string
  width?: number | string
  className?: string
  icon?: string
}

export const TextInput: FC<TextInputProps> = ({
  register,
  type = 'text',
  placeholder,
  unit,
  width = undefined,
  className = '',
  icon = undefined,
}) => {
  return (
    <div className="flex justify-start relative">
      {icon && (
        <span className="material-icons absolute left-3 top-1/2 transform -translate-y-1/2 text-main-darkgray">
          {icon}
        </span>
      )}
      <input
        type={type}
        placeholder={placeholder}
        className={`w-full ${icon ? 'pl-10' : 'pl-3'} pr-3 py-2 border border-main-bordergray placeholder:text-main-bordergray rounded-md focus:outline-none focus:border-2 focus:border-main-green ${className}`}
        style={{ width }}
        {...register}
      />
      {unit && (
        <div className="flex flex-col justify-center">
          <p className="pl-1 whitespace-nowrap">{unit}</p>
        </div>
      )}
    </div>
  )
}
